import ReactDOM from 'react-dom';

function enhance(ParentClass) {
  return class ResponsiveElementEnhancer extends ParentClass {
    constructor() {
      super(...arguments);

      this._rawSetRespWidth = this._rawSetRespWidth.bind(this);
      this._setRespWidth = _.debounce(this._rawSetRespWidth, 250, {
        leading: true,
      }).bind(this);
    }

    _rawSetRespWidth() {
      try {
        var node = ReactDOM.findDOMNode(this);
      } catch (e) {
        return;
      }
      const element = { width: node.offsetWidth };
      const breakpoints =
        element.width >= 710 ? { large: true } : { large: false };
      this.setState({ breakpoints });
    }

    componentDidMount() {
      this._setRespWidth();
    }

    componentDidUpdate(prevProps, prevState) {
      window.addEventListener('resize', this._rawSetRespWidth);
      if (prevState.small !== this.state.small) {
        this._setRespWidth();
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this._rawSetRespWidth);
    }
  };
}

export default enhance;
